export default __webpack_public_path__ + "static/media/ConfigScalyrAgentIncreaseThroughput.fb64a223.md";